/* eslint-disable no-unused-vars */
import { getSitesInfoForSitesListingPage } from './sites/sites-info-for-listing-page';
import { getSiteDetailInfo } from './sites/site-detail-info';
import { getParentSiteDetails } from './sites/parent-site-details-info';
import { filterSiteListBasedOnCoordinates } from '@components/site-listing/helper';

const SitesSelector = {
  getSitesWithAllTasks: async ({
    parentSite = [],
    id = '',
    withChild = true,
    templatesIds = '',
    getDataFromCache = false,
    formWrapper = false,
    store,
    showMapView = false,
    oldSiteList = [],
    siteTypeQuery = null
  }) => {
    if (showMapView && oldSiteList?.length > 0) {
      const response = await createSiteListsThatHaveCoordinateEvent({ sitesList: oldSiteList });
      return response;
    } else {
      const response = await getSitesInfoForSitesListingPage({
        parentSite,
        id,
        withChild,
        templatesIds,
        getDataFromCache,
        formWrapper,
        store,
        siteTypeQuery
      });
      if (showMapView) {
        const siteWithDistance = await createSiteListsThatHaveCoordinateEvent({
          sitesList: response
        });
        return siteWithDistance;
      } else return response;
    }
  },
  getSiteWithEquipment: async ({
    siteId = '',
    getDataFromCache = false,
    store,
    selectedTaskType = null
  }) => {
    const response = await getSiteDetailInfo({ siteId, getDataFromCache, store, selectedTaskType });
    if (response.distance) {
      const coordinatesList = await filterSiteListBasedOnCoordinates({
        filterSitesList: [
          {
            ...response,
            siteId,
            allTasksForSite: response.tasks,
            default: true
          }
        ]
      });
      return {
        ...response,
        coordinatesList
      };
    } else {
      return response;
    }
  },

  getParentSiteDetailsInfo: async ({
    siteId = '',
    equipmentsWithWO = false,
    withChild = true,
    templatesIds = '',
    store,
    getWorkRequestData = false,
    selectedTaskType = null
  }) => {
    const response = await getParentSiteDetails({
      siteId,
      equipmentsWithWO,
      withChild,
      templatesIds,
      store,
      getWorkRequestData,
      selectedTaskType
    });

    if (response.children?.length > 0) {
      const coordinatesListOfChild = await filterSiteListBasedOnCoordinates({
        filterSitesList: [
          ...response.children,
          {
            ...response,
            siteId,
            allTasksForSite: response.tasks,
            default: true
          }
        ]
      });
      return {
        ...response,
        siteId,
        coordinatesListOfChild
      };
    } else {
      return response;
    }
  }
};
export default SitesSelector;

const createSiteListsThatHaveCoordinateEvent = ({ sitesList = [] }) => {
  return new Promise((resolve) => {
    let copySitesList = [...sitesList];
    const siteListHaveCoordinate = copySitesList?.filter((filterDistanceSite) => {
      const distance = filterDistanceSite?.distance || 0;
      return parseFloat(distance) > 0 ? true : false;
    });
    resolve(siteListHaveCoordinate);
  });
};
